// extracted by mini-css-extract-plugin
export default {"banner":"banner_banner__K6q-A","layer":"banner_layer__YvjnB","image":"banner_image__IuY3Y","text":"banner_text__TmKQ9"};